var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M38.732 8a.98.98 0 0 1 .98.86q.118.99.188 2.03.1 1.494.1 2.192 0 6.676-2.406 12.754-2.272 5.646-5.528 9.693a.98.98 0 0 1-.982.336l-8.342-1.888a1.025 1.025 0 0 1-.711-1.39q1.57-3.856 2.53-8.544 1.203-5.48 1.203-10.363v-.797q0-.698-.1-1.495 0-.897-.1-1.794 0-.228-.007-.444C25.54 8.54 26.01 8 26.617 8zM17.18 8a.98.98 0 0 1 .979.86q.118.99.188 2.03.1 1.494.1 2.192 0 6.676-2.406 12.754-2.272 5.646-5.527 9.693a.98.98 0 0 1-.983.336l-8.342-1.888a1.025 1.025 0 0 1-.711-1.39q1.57-3.856 2.53-8.544 1.204-5.48 1.204-10.363v-.797q0-.698-.1-1.495 0-.897-.101-1.794 0-.228-.006-.444C3.984 8.54 4.454 8 5.063 8z"
  })));
};
export default SvgQuote;